import { FaPerson } from "react-icons/fa6";

const FundraiserCard = ({
  campaignData = { logo: "",by:"",for:"" }, // Default campaignData to prevent undefined errors
  by = "Demo Trust",
  forOrganization = "Demo Trust",
}) => {
 
  const logoUrl =
  campaignData?.charity?.logo
    ? import.meta.env.VITE_API_CLOUDFRONT_URL + campaignData.charity.logo
    : "https://cdn.filestackcontent.com/ATwlgNAAsQsyfsNEw94Cgz/output=format:jpg,quality:70/resize=width:55,height:55,fit:max/https://cdn.filestackcontent.com/PL00a65Trdlp6d8CKZ5w";
   const byVal = campaignData.user?.first_name +" "+campaignData.user?.last_name
   const forVal = campaignData.name

  return (
    <div className="py-6 w-72 px-3 sm:px-6  rounded-lg">
      <div className="campaign-fundraiser-detail">
        <div className="flex w-full items-center justify-start gap-4">
          {/* Avatar */}
          <div className="flex items-center justify-center mr-4">
            <div className="charity-logo-avatar-container bg-teal-500 rounded-full w-14 h-14 flex items-center justify-center p-1 overflow-hidden">
              <a href="#">
                <img
                  className="charity-avatar object-cover w-full h-full"
                  src={logoUrl} // Dynamically set logo URL
                  alt="Charity Logo"
                />
              </a>
            </div>
          </div>

          {/* Fundraiser Details */}
          <div className="flex flex-col items-start justify-center w-full">
            <span>Fundraising by</span>
            <div className="flex items-center justify-center gap-2">
              <div className="fundraiser">{byVal}</div>
            </div>
            <span>
              for <span className="title">{forVal}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FundraiserCard;
